import { combineReducers } from "redux"

import contacts from './contacts'

export default combineReducers ({
    contacts,
})